// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function ConfettiIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M13.936 6.579a1.974 1.974 0 0 0-3.25.721L4.125 25.347A1.979 1.979 0 0 0 5.97 28a2 2 0 0 0 .682-.125L24.7 21.312a1.976 1.976 0 0 0 .722-3.25L13.936 6.58ZM12.895 23.48 8.52 19.105l1.645-4.526 7.256 7.256-4.526 1.645Zm-6.875 2.5 1.75-4.801 3.056 3.056L6.02 25.98Zm13.48-4.9-8.58-8.58 1.625-4.484 11.429 11.429L19.5 21.08ZM20 9c.019-.676.182-1.34.48-1.947C21.142 5.729 22.392 5 24 5c.837 0 1.375-.286 1.706-.901.175-.344.275-.721.294-1.107A1 1 0 0 1 28 3c0 1.607-1.065 4-4 4-.837 0-1.375.286-1.706.901A2.75 2.75 0 0 0 22 9.008 1 1 0 0 1 20 9Zm-3-4V2a1 1 0 1 1 2 0v3a1 1 0 0 1-2 0Zm12.707 10.293a1 1 0 0 1-1.415 1.413l-2-2a1 1 0 1 1 1.415-1.415l2 2.002Zm.61-5.344-3 1a1 1 0 1 1-.633-1.898l3-1a1 1 0 0 1 .632 1.898Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
